























































import { Component, Vue, Watch } from 'vue-property-decorator';
import CodeEditor from '@/components/CppCodeEditor.vue';
import { RealmApi } from '@/services/api/api.realms';
import bus from '@/core/bus';
import { BusConstants, ModalConstants } from '@/core/constants';
import debounce from 'lodash-es/debounce';
import FilePicker from '@/components/dashboard/FilePicker.vue';
import { RealmLogType, TDirectory, TFile } from '@/types/apiServerContract';
import urlHelperService from '@/services/url/urlHelper.service';

@Component({
    components: { CodeEditor, FilePicker }
})
export default class CoreScripts extends Vue {
    directories: TDirectory[] = [];
    selectedFile: TFile | null = null;
    fileContent: string = '';

    updateLuaFileDebounce = debounce(this.updateLuaFile, 1000);
    fileUpdateInProgress: boolean = false;
    fileIsInSyncWithServer: boolean = true;

    async getFileContent() {
        if (!this.selectedFile) return;
        this.fileContent = '';
        const result = await RealmApi.GetLUAFileContent(this.selectedFile.fullPath);
	    this.fileContent = result.data;
    }

    async updateLuaFile() {
        if (!this.selectedFile) return;

        this.fileUpdateInProgress = true;
        this.fileIsInSyncWithServer = false;

        try {
            const result = await RealmApi.UploadLuaFileContent({
                fileName: this.selectedFile.fullPath,
                content: this.fileContent
            });

            this.fileIsInSyncWithServer = result.data;
        } finally {
            this.fileUpdateInProgress = false;
        }
    }

    async createFolder(folderPath: string) {
        if (this.fileUpdateInProgress) return;

        this.fileUpdateInProgress = true;

        try {
            const result = await RealmApi.CreateLUAFolder(folderPath);
            if (result) {
	            this.directories = result.directories;
            }
        } finally {
            this.fileUpdateInProgress = false;
        }
    }

    async createFile(filePath: string) {
        if (this.fileUpdateInProgress) return;

        this.fileUpdateInProgress = true;

        try {
            const result = await RealmApi.CreateLUAFile(filePath);

            if (result) {
	            this.directories = result.directories;
            }
        } finally {
            this.fileUpdateInProgress = false;
        }
    }

    async deleteLUAFile() {
        if (!this.selectedFile) return;

        const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this file?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

        this.fileUpdateInProgress = true;

        try {
            const result = await RealmApi.DeleteLUAFile({
                fileName: this.selectedFile.fullPath
            });

            this.selectedFile = null;
            urlHelperService.removeQueryParam('selectedFile');

            if (result) {
                this.getLUAFiles();

                this.$bvToast.toast('File deleted successfully', {
                    variant: 'success',
                    title: 'Success'
                });
            }
        } finally {
            this.fileUpdateInProgress = false;
        }
    }

    showFileHistory() {
	    bus.emit(BusConstants.RealmLogHistoryType, RealmLogType.LUAUpload);
	    this.$bvModal.show(ModalConstants.RealmLogHistoryWindow);
    }

    showDeleteHistory() {
	    bus.emit(BusConstants.RealmLogHistoryType, RealmLogType.LUADelete);
	    this.$bvModal.show(ModalConstants.RealmLogHistoryWindow);
    }

    @Watch('fileContent')
    onContentChange(a: string, b: string) {
        if (b.length !== 0 && a.length !== 0) {
            this.fileUpdateInProgress = true;
            this.updateLuaFileDebounce();
        }
    }

    async getLUAFiles() {
        this.selectedFile = null;
        this.fileContent = '';

        const result = await RealmApi.GetLUAFiles();
	    this.directories = result.directories;
    }

    saveAndBuild() {
        this.$bvModal.show(ModalConstants.BuildProcessWindow);
    }

    created() {
        this.getLUAFiles();

	    bus.on(BusConstants.SelectedRealmChanged, this.getLUAFiles);
    }

    beforeDestroy() {
	    bus.off(BusConstants.SelectedRealmChanged, this.getLUAFiles);
    }
}
